import React, { useState }  from 'react'
export default function Display() {
    const [display, setDisplay] = useState(false)
      return (
        <div className='text-center p-1'>
        <b>Payment js</b><br/>
          <button className='plane-btn' onClick={() => setDisplay(!display)}>{display ? <>▲</>:<>▼</>}</button><br/>
          {display ? <>display</>:''}
        </div>
      )
  }